import config from 'constants/config'

export const AGENT_HUB_TERMS_URL = 'https://luxuryescapes.com/au/terms-and-conditions'
export const AGENT_HUB_POLICY_URL = 'https://luxuryescapes.com/au/privacy-policy'
export const AGENTHUB_SUPPORT_EMAIL = 'agenthubsupport@luxuryescapes.com'
export const AGENT_HUB_PAYOUT_SETUP_URL = `${config.AGENT_PORTAL_URL}/settings?display-payout-details-dialog=true`
